var map = {
	"./close_session_fill.svg": "d4cf",
	"./close_session_line.svg": "ddfb",
	"./com_tag.svg": "0768",
	"./guidance_qr.svg": "4fc1",
	"./img_selector.svg": "504d",
	"./input_question.svg": "097d4",
	"./message_bubble.svg": "402a",
	"./message_bubble_mobile.svg": "5393",
	"./mobile_normal.svg": "643f",
	"./mobile_normal_bubble.svg": "8526",
	"./mobile_wxkf.svg": "080a",
	"./new_mobile_customer_connect.svg": "9754",
	"./new_mobile_guidance.svg": "a983",
	"./new_mobile_normal.svg": "4609",
	"./new_mobile_normal_bubble.svg": "a5d5",
	"./new_pc_normal.svg": "c722",
	"./new_pc_normal_bubble.svg": "7cc5",
	"./new_pc_simple.svg": "a422",
	"./new_pc_simple_bubble.svg": "682d",
	"./no.svg": "b8a0",
	"./notice_bar.svg": "106c",
	"./notice_bar_mobile.svg": "04d3",
	"./pc_normal.svg": "d154",
	"./pc_normal_bubble.svg": "3d11",
	"./pc_simple.svg": "4dc1",
	"./pc_simple_bubble.svg": "76ee",
	"./pc_typing.svg": "4d0b",
	"./pc_wxkf.svg": "39a6f",
	"./screenshot.svg": "ea5d",
	"./send_video_file.svg": "28774",
	"./yes.svg": "80a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f3f";